/**
 * Admin-portal entitlement check.
 *
 * Every `/admin/*` route must reject users who lack the Admin portal
 * entitlement. The SCRUM-131 backend ships `AuthMeResponseDto.portals`
 * as a REQUIRED, always-present array, so the check collapses to a
 * simple membership test:
 *
 *   - `me === null`                  → reject (not authenticated)
 *   - `me.portals.includes('Admin')` → allow
 *   - otherwise                      → reject
 *
 * There is no tri-state null branch and no build-mode special-casing
 * any more — the contract guarantees the array.
 */

import { type Me } from './use-me.js';

export function hasAdminPortalEntitlement(me: Me | null): boolean {
  return me !== null && me.portals.includes('Admin');
}
